import styled from 'styled-components';
import TextField from '@sdk/components/forms/TextField';

export const Anchor = styled.a`
  color: ${({ theme }) => theme.colors.iconGray};
  font-size: 12px;
  text-decoration: underline;

  &:not(:hover) {
    opacity: 0.9;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ReadonlyTextField = styled(TextField)`
  input {
    color: ${({ theme }) => theme.colors.iconGray};
  }
`;

export const LinkFieldContainer = styled.div`
  flex: 2;
  position: relative;
  margin-right: 10px;
`;

export const ActionConfirmation = styled.div<{ isShown: boolean }>`
  background: ${({ theme }) => theme.colors.success};
  color: ${({ theme }) => theme.colors.white};
  font-size: 12px;
  padding: 4px 25px;
  border-radius: 30px;
  position: absolute;
  visibility: none;
  opacity: 0;
  transition-property: visibility, opacity, top;
  transition-duration: 0.3s, 0.3s, 0.3s;
  transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
  transition-delay: 0.3s, 0s, 0s;
  top: 100%;
  transform: translateY(-50%);
  z-index: 2;
  right: 5px;
  ${({ isShown }) =>
    isShown
      ? `
    transition-delay: 0s, 0s, 0s;
    visibility: visible;
    opacity: 1;
    top: 50%;
  `
      : ''}
`;

export const ActionButtonContainer = styled.div`
  position: absolute;
  right: 67px;
`;
